export * from './aside.directive';



// WEBPACK FOOTER //
// /var/www/backend/src/app/core/directives/aside/index.ts